export function formatDateTime(date: Date) {
  const timeFormat: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  return date.toLocaleString("de-DE", timeFormat);
}

export function formatDateOnly(date: Date) {
  const timeFormat: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return date.toLocaleString("de-DE", timeFormat);
}

export function stringToDateWithoutTime(dateString: string | null) {
  if (!dateString) return { date: "", beforeNow: false };
  const date = new Date(dateString);

  if (date.getTime() < new Date("2000-01-01").getTime()) return { date: "", beforeNow: false };
  const timeFormat: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return {
    date: date.toLocaleString("de-DE", timeFormat),
    beforeNow: date.getTime() < new Date().getTime(),
  };
}
